import React, { useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  styled,
  Typography,
} from "@mui/material";
import LinkVaultPreview from "../../components/WheelGallery/GallerySettings/children/LinkVault/children/LinkVaultPreview";
import { useParams, useNavigate } from "react-router-dom";
import { useGetUserProfileById } from "../../services/queries";
import { useDispatch, useSelector } from "react-redux";
import { selectProfile, setProfile } from "../../redux/reducers/gallery";
import { ASSETS } from "../../utils/config";
import { PATH } from "../../utils/config";
import ReportModal from "../../components/ReportModal";
import WheelIcon from "../../assets/images/hidden-gallery.svg";
import HatIcon from "../../assets/images/hat.svg";
import GlassesIcon from "../../assets/images/glasses.svg";

const GradientContainer = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const NoDataContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "24px",
  gap: "24px",
  borderRadius: "8px",
  boxShadow: "0px 0px 9.3px 0px #3B3B3B1C",
  width: "382px",
  flexDirection: "column",
  backgroundColor: "#fff",
});

const IconContainer = styled(Box)({
  position: "relative",
  width: "120px",
  height: "120px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const LinkVaultPage = ({}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: profileData,
    isLoading,
    isError,
    error,
  } = useGetUserProfileById(id);


  useEffect(() => {
    if (profileData) {
      dispatch(setProfile(profileData?.data));
    }
  }, [profileData]);

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column",
        overflow: "hidden",
        background: `
          linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 70%),
          conic-gradient(from 90deg at 49.13% 50%, #F5EEDE -41.73deg, #CCFEFF 37.8deg, #F7FED5 140.4deg, #FDCFFE 216deg, #F5EEDE 318.27deg, #CCFEFF 397.8deg)
        `,
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: { xs: "auto", sm: "80px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: { xs: "12px 16px", sm: "16px 40px" },
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "#FFFFFF",
          backdropFilter: "blur(8px)",
          boxShadow: "0px 4px 7px 0px #00000014",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 0 },
          zIndex: 1000,
        }}
      >
        <Box sx={{ cursor: "pointer" }} onClick={() => navigate("/")}>
          <img src={ASSETS.iyugaLogo} height={40} width={40} alt="Iyuga Logo" />
        </Box>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{
              borderColor: "#9B5AF8",
              color: "#9B5AF8",
              width: { xs: "100px", sm: "140px" },
              textTransform: "capitalize",
              fontSize: { xs: "14px", sm: "16px" },
              py: { xs: "6px", sm: "8px" },

              "&:hover": {
                borderColor: "#9B5AF8",
                backgroundColor: "rgba(129, 69, 155, 0.04)",
              },
            }}
            onClick={() => navigate(PATH.LOGIN)}
          >
            Login
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#9B5AF8",
              color: "white",
              width: { xs: "100px", sm: "130px" },
              textTransform: "capitalize",
              fontSize: { xs: "14px", sm: "16px" },
              py: { xs: "6px", sm: "8px" },

              "&:hover": {
                backgroundColor: "#6A3580",
              },
            }}
            onClick={() => navigate(PATH.SIGNUP)}
          >
            Sign Up
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: { xs: "110px", sm: "80px" }, // Adjusted to account for potentially taller header
          p: 3,
          maxHeight: { xs: "calc(100vh - 150px)", sm: "calc(100vh - 120px)" }, // Adjusted for mobile
          overflowY: "auto",
        }}
      >
        {isLoading ? (
          <CircularProgress sx={{ color: "#9B5AF8" }} />
        ) : isError ? (
          error?.response?.status === 403 ? (
            <GradientContainer>
              <NoDataContainer>
                <IconContainer>
                  <img src={WheelIcon} alt="hidden" />
                  <img
                    src={HatIcon}
                    alt="hat"
                    style={{ position: "absolute", right: "5px", top: "5px" }}
                  />
                  <img
                    src={GlassesIcon}
                    alt="glasses"
                    style={{ position: "absolute", right: "0px", top: "45px" }}
                  />
                </IconContainer>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#565556",
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "500",
                      fontFamily: "DM Sans",
                    }}
                  >
                    Oops! Nothing to see here!
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{
                      width: "100px",
                      fontSize: "12px",
                      borderColor: "#9B5AF8",
                      color: "#9B5AF8",
                      "&:hover": {
                        borderColor: "#9B5AF8",
                        backgroundColor: "rgba(129, 69, 155, 0.04)",
                      },
                    }}
                    onClick={() => navigate("/")}
                  >
                    Go Back
                  </Button>
                </Box>
              </NoDataContainer>
            </GradientContainer>
          ) : (
            <Typography
              sx={{
                color: "#565556",
                textAlign: "center",
                fontSize: "16px",
                fontFamily: "DM Sans",
              }}
            >
              Failed to load profile data
            </Typography>
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", sm: "70%", md: "50%", lg: "25%" },
              margin: "auto",
              msOverflowStyle: "none", // IE and Edge
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, Opera
              },
            }}
          >
            <LinkVaultPreview
              showMenu
              fullPage
              links={profileData?.data?.external_links}
            />
          </Box>
        )}
      </Box>

      <ReportModal />
    </Box>
  );
};

export default LinkVaultPage;
